module.exports = __webpack_public_path__ + "img/0Q3B7166_Foamcore_MockedUp.689f96b0.jpg";